import { getGap } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneSize } from '@Components/BigBrowse/Model/ModelTypes';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { getMultiSectionHeroCard } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/heroCard';
import { getCentralIndexes } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerFullWidth/helpers/headerFullWidth.helpers';
import { isOdd } from '@Utils/miscUtils';

export async function addHeaderHero(viewData: ViewData): Promise<ViewData> {
  const { layoutTable } = viewData;
  const heroSize = getHeroSize(viewData);

  const numOfColumns = layoutTable!.length;
  const [heroColumnIndex, gapColumnIndex] = getHeroColumnIndexes(numOfColumns);

  // if there is a center column, displace the Hero Image to the left to make it centered
  const dx = isOdd(viewData.layoutTable!.length)
    ? -viewData.columnWidth! / 2
    : 0;

  const card = viewData.modelData?.header?.showHeroMedia
    ? getMultiSectionHeroCard(viewData, heroSize, dx)
    : getGap(heroSize);

  layoutTable![heroColumnIndex].push(card);

  layoutTable![gapColumnIndex].push(
    getGap({ width: viewData.columnWidth!, height: heroSize.height })
  );

  return viewData;
}

export function getHeroColumnIndexes(numOfColumns: number): [number, number] {
  return getCentralIndexes(numOfColumns).slice(-2) as [number, number];
}

function getHeroSize(viewData: ViewData): PlaneSize {
  const side = viewData.columnWidth! * 2 + viewData.columnGap!;

  return { width: side, height: side };
}
